module.exports = __webpack_public_path__ + "static/cor1-a9c56639ea26404cfda6adaa97aa473e.png";